export default __webpack_public_path__ + "img/placeholder-product.asset.59c98cf1.png";